import { Vue } from 'vue-property-decorator';
import moment from 'moment';

Vue.filter('firstLetterUppercase', function (value: string) {
    return value?.charAt(0).toUpperCase() + value?.slice(1);
});